export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--4.464d39df.png";